import React, { useEffect, useState } from 'react';
import "./Contact.css";
import { EnvironmentOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';
import { Button, Input } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { BsBuildings } from "react-icons/bs";

function Contact () {
    let [ object, setObject ] = useState( {} );

    useEffect( () => {
        window.scrollTo( 0, 0 );
    }, [] );

    return (
        <div className='contact-container'>
            <div className='contact-inner-container'>
                <div className='contact-banner'>
                    <img src={require( "../../images/contact/banner.avif" )} alt="contact-banner" height={"100%"} width={"100%"} />
                    <div className='contact-banner-text'>
                        <div>Contact Us</div>
                        <div>For inquiries, support, or any questions about our products, contact us or fill the form.</div>
                        <div>
                            <EnvironmentOutlined />
                            <div>
                                <span><b>Factory: </b>Plot No. 29, Sector 31B, IMT, Delhi<br />Road Rohtak - 124001 (Haryana), INDIA</span>
                                <span><b>Regd. Office: </b>A1/2C, Chanakya Place, Pankha<br />Road, New Delhi-110059, INDIA</span>
                            </div>
                        </div>
                        <div>
                            <PhoneOutlined />
                            <div>
                                <a href="tel:+919958622334">+91 99586 22334</a>
                                <a href="tel:+919253545001">+91 92535 45001</a>
                            </div>
                        </div>
                        <div>
                            <BsBuildings />
                            <div>
                                <span>+91 11 66173572</span>
                            </div>
                        </div>
                        <div>
                            <MailOutlined />
                            <div>
                                <a href="mailto:sales@aerofpl.com">sales@aerofpl.com</a>
                                <a href="mailto:jasmer@aerofpl.com">jasmer@aerofpl.com</a>
                            </div>
                        </div>
                    </div>
                </div>
                <form onSubmit={( event ) => {
                    event.preventDefault();
                    console.log( object );
                }}>
                    <div className='input-container'>
                        <label htmlFor="name">Name</label>
                        <Input id='name' placeholder='Enter the your name' value={object.name} onChange={( event ) => {
                            setObject( { ...object, name: event.target.value } );
                        }} required />
                    </div>
                    <div className='input-container'>
                        <label htmlFor="companyName">Company Name</label>
                        <Input id='companyName' placeholder='Enter the company name' value={object.companyName} onChange={( event ) => {
                            setObject( { ...object, companyName: event.target.value } );
                        }} required />
                    </div>
                    <div className='input-container'>
                        <label htmlFor="email">Mail ID</label>
                        <Input id='email' type="email" placeholder='Enter the Mail ID' value={object.email} onChange={( event ) => {
                            setObject( { ...object, email: event.target.value } );
                        }} required />
                    </div>
                    <div className='input-container'>
                        <label htmlFor="phone">Phone Number</label>
                        <Input id='phone' type="tel" placeholder='Enter the number' addonBefore="+91" value={object.phone} onChange={( event ) => {
                            if ( !isNaN( event.target.value ) ) {
                                setObject( { ...object, phone: event.target.value } );
                            }
                        }} required />
                    </div>
                    <div className='input-container'>
                        <label htmlFor="message">Message</label>
                        <TextArea style={{ height: "120px" }} placeholder='Enter the message' id='message' value={object.message} onChange={( event ) => {
                            setObject( { ...object, message: event.target.value } );
                        }} required />
                    </div>
                    <Button htmlType='submit'>Submit</Button>
                    <img src={require( "../../images/logo.avif" )} alt="logo" height={"100%"} width={"100%"} />
                </form>
            </div>
        </div>
    )
}

export default Contact
